import { useMediaQuery } from "@/hooks";
import React from "react";
import classNames from "classnames";
import { formatCurrency } from "@/lib/currency/currency";
import { Spacer } from "@/offering/spacer";
import { PortalButton } from "./portal_button";
import { formatDate } from "@/offering/date_utils";
import { isNumber } from "lodash";

interface ManageMembershipDetailsContentProps {
  startDate: string;
  endDate?: string | null;
  billDate?: string | null;
  billTotal?: number | null;
  currency?: string | null;
  cancellationDate?: string | null;
  isCancelled: boolean;
  onClickDetails: () => void;
}

export function ManageMembershipDetailsContent({
  startDate,
  endDate,
  billDate,
  billTotal,
  currency,
  cancellationDate,
  isCancelled,
  onClickDetails,
}: ManageMembershipDetailsContentProps) {
  const { device } = useMediaQuery();
  const hasBill = !!(billDate && isNumber(billTotal) && currency);

  if (device !== "mobile" && isCancelled) {
    return (
      <div className="d-flex justify-content-between align-items-start">
        <div className="col-5">
          <div>
            Start date: <b>{formatDate(startDate)}</b>
          </div>
          {cancellationDate && (
            <>
              <Spacer size={12} />
              <div>
                Cancellation date: <b>{formatDate(cancellationDate)}</b>
              </div>
            </>
          )}
        </div>
        <div className="col-5 ps-5 border-start">
          {hasBill && (
            <div>
              Next bill: <b>{formatCurrency(billTotal, currency)}</b> on{" "}
              <b>{formatDate(billDate)}</b>
            </div>
          )}
          {endDate && (
            <>
              <Spacer size={12} />
              <div>
                End date: <b>{formatDate(endDate)}</b>
              </div>
            </>
          )}
        </div>
        {hasBill && (
          <PortalButton appearance="text" onClick={onClickDetails}>
            Details
          </PortalButton>
        )}
      </div>
    );
  }

  return (
    <div>
      <div>
        Start date: <b>{formatDate(startDate)}</b>
      </div>
      {hasBill && (
        <>
          <Spacer size={12} />
          <div className="d-flex justify-content-between">
            <div>
              Next bill:{" "}
              <b
                className={classNames(
                  device === "mobile" && "text-decoration-underline"
                )}
                onClick={device === "mobile" ? onClickDetails : undefined}
              >
                {formatCurrency(billTotal, currency)}
              </b>{" "}
              on <b>{formatDate(billDate)}</b>
            </div>
            {device !== "mobile" && (
              <PortalButton appearance="text" onClick={onClickDetails}>
                Details
              </PortalButton>
            )}
          </div>
        </>
      )}
      {cancellationDate && (
        <>
          <Spacer size={12} />
          <div>
            Cancellation date: <b>{formatDate(cancellationDate)}</b>
          </div>
        </>
      )}
      {endDate && (
        <>
          <Spacer size={12} />
          <div>
            End date: <b>{formatDate(endDate)}</b>
          </div>
        </>
      )}
    </div>
  );
}
